import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const timelineService = {
  getTimelineData: async (user, pairs) => {
    return (await axios.post(`${NODE_BASE_URL}/timeline/bulk`, { pairs }, getAxiosOptions(user)))
      .data
  },
}
